import { Component, OnInit, Input } from '@angular/core';
import { UserService } from 'src/app/services/user.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { HttpAlertService } from 'src/app/services/http-alert.service';
import { TranslateService } from '@ngx-translate/core';
import { AdminService } from 'src/app/services/admin.service';
import { environment } from 'src/environments/environment';
import { User } from 'src/app/intefaces/user.interface';

@Component({
    selector: 'app-user-details-form',
    templateUrl: './user-details-form.component.html',
    styleUrls: ['./user-details-form.component.scss']
})
export class UserDetailsFormComponent implements OnInit {
    userDetailsForm: FormGroup;
    isEditing: boolean = false;
    formPreviousValues: any;
    isDataReady: boolean = false;
    user: User;
    myImagePath: string = '';
    _url = environment.endpoint + environment.apiPath;
    @Input() isAdmin: boolean;
    @Input() userId: number;

    constructor(
        private userService: UserService,
        private adminService: AdminService,
        private formBuilder: FormBuilder,
        private alertService: HttpAlertService,
        private translate: TranslateService) {

        this.userDetailsForm = this.formBuilder.group({
            id: [0, Validators.required],
            login: ['', Validators.required],
            name: ['', Validators.required],
            surname: ['', Validators.required],
            phone: ['', Validators.required]
        });
    }

    ngOnInit(): void {
        if (this.isAdmin) {
            this.adminService.getUserWithDetails(this.userId).subscribe((response: any) => {
                this.populateForm(response.data.user);
            });
        } else {
            this.userService.getMyDetails().subscribe((response: any) => {
                this.populateForm(response.data.user);
            });
        }
    }

    private populateForm(data: User) {
        this.userDetailsForm.patchValue(data);
        this.userDetailsForm.patchValue(data.user_details);

        const fullPath = data.user_details.img_path;
        if (fullPath != null) {
            const finalPath = fullPath.substr(fullPath.indexOf('/'), fullPath.length);
            this.myImagePath = `${environment.avatarUrl}${finalPath}`;
        }

        setTimeout(() => {
            this.disabledForm();
        }, 100);
        this.isDataReady = true;
    }

    public startEditing() {
        this.formPreviousValues = this.userDetailsForm.value;
        this.enableForm();
    }

    public cancelEditing() {
        this.userDetailsForm.setValue(this.formPreviousValues);
        this.disabledForm();
    }

    public onSubmit() {
        this.disabledForm();
        if (this.isAdmin) {
            this.adminService.updateUserDetailsByAdmin(this.userDetailsForm.value).subscribe(
                result => {
                    this.translate.get('data_updated_success').subscribe(t => {
                        this.alertService.success(t);
                    });
                }, error => {
                    this.translate.get('data_updated_error').subscribe(t => {
                        this.alertService.error(t);
                    });
                }
            );
        } else {
            this.userService.updateUserDetails(this.userDetailsForm.value).subscribe(
                result => {
                    this.translate.get('data_updated_success').subscribe(t => {
                        this.alertService.success(t);
                    });
                }, error => {
                    this.translate.get('data_updated_error').subscribe(t => {
                        this.alertService.error(t);
                    });
                }
            );
        }
    }

    private disabledForm() {
        this.userDetailsForm.disable();
        this.isEditing = false;
    }

    private enableForm() {
        this.userDetailsForm.get('name').enable();
        this.userDetailsForm.get('surname').enable();
        this.userDetailsForm.get('phone').enable();
        this.isEditing = true;
    }


}
